// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__CPRKC","notes":"Notes_notes__20qnr","note":"Notes_note__3AYlM","markdown":"Notes_markdown__1uaB2"};